// This schema defines the field-level permissions for the Process Manager Access tab.
// Each section corresponds to a Tab in the Employee Transaction Modal.

import { FEATURES } from "../config/features";


/// prerequisite => required to have access with, both / all should be selected



export const PROCESSOR_ACCESS_SCHEMA = {
  "assignment-details": {
    tabLabel: "Assignment Details Tab",
    permissions: [
      { backendProp: "allowEffectiveFrom", displayLabel: "Enable Effective From Date", targetField: "effectiveFrom" },
      { backendProp: "allowOnLeave", displayLabel: "Enable On Leave Toggle", targetField: "isOnLeave" },
      { backendProp: "allowDestinationVessel", displayLabel: "Enable Destination Vessel", targetField: "destinationVesselId", dependsOn: "isOnLeave", dependsValue: false },
      { backendProp: "allowDestinationHead", displayLabel: "Enable Destination Head", targetField: "destinationHeadId" },
      { backendProp: "allowWithBenefits", displayLabel: "Enable With Benefits Toggle", targetField: "isWithBenefits" },
      { backendProp: "allowRemarks", displayLabel: "Enable Remarks Field", targetField: "remarks" },
      { backendProp: "allowIsActive", displayLabel: "Enable Active Status Toggle", targetField: "isActive" },
      { backendProp: "allowWithTime", displayLabel: "Enable With Time Toggle", targetField: "isWithTime" },
    ]
  },
  "employee-info": {
    tabLabel: "Employee Info Tab",
    label: "Employee Info",
    permissions: [
      // -- Employee Assignment --
      { backendProp: "allowAssignedTo", displayLabel: "Enable Assigned To Manager", targetField: "assignedToEmployeePersonalInformationId" },

      // -- Employee Medical Clearance --
      { backendProp: "allowMedicalClearance", displayLabel: "Enable Medical Clearance", targetField: "medicalClearanceId", dependsOn: "isOnLeave", dependsValue: false },

      // -- Employee Info Fields (disabled fields)--
      { backendProp: "allowEmployeeType", displayLabel: "Enable Employee Type View", targetField: "employeeType", isDisabledField: true },
      { backendProp: "allowDestination", displayLabel: "Enable Employee Destination View", targetField: "destination", isDisabledField: true },
      { backendProp: "allowRegularTitle", displayLabel: "Enable Regular Title View", targetField: "regularTitle", isDisabledField: true }, // Position
      { backendProp: "allowRegularVessel", displayLabel: "Enable Employee Vessel View", targetField: "vesselType", isDisabledField: true },
      { backendProp: "allowVesselType", displayLabel: "Enable Vessel Type View", targetField: "vesselType", isDisabledField: true },
      { backendProp: "allowViaCaptain", displayLabel: "Enable Via Captain View", targetField: "vesselType", isDisabledField: true }, // Destination Head

      // -- Temporary Assignment Fields --
      { backendProp: "allowTempEmployeeType", displayLabel: "Enable Temp Employee Type", targetField: "tempEmployeeTypeId" , dynamicFilterTagging: ["EMPLOYEE_TYPE"]},
      { backendProp: "allowTempClassification", displayLabel: "Enable Temp Classified As", targetField: "classificationId" },
      { backendProp: "allowTempDepartment", displayLabel: "Enable Temp Unit/Department", targetField: "departmentId", dynamicFilterTagging: ["DEPARTMENT_MSC_TOGGLE, DEPARTMENT"]},
      { backendProp: "allowTempPosition", displayLabel: "Enable Temp Position/Title", targetField: "tempPositionId", dynamicFilterTagging: ["POSITION_MSC_TOGGLE, POSITION"] },
      { backendProp: "allowTempVessel", displayLabel: "Enable Temp Vessel", targetField: "tempVesselId" },
      { backendProp: "allowTempEmployment", displayLabel: "Enable Temp Employment Type", targetField: "employmentId" },

      // -- Employee Status Field --
      { backendProp: "allowTempEmployeeStatus", displayLabel: "Enable Temp Employee Status", targetField: "tempEmployeeStatusId", dependsOn: "isOnLeave", dependsValue: true },
    ]
  },
  "compensation": {
    tabLabel: "Compensation Tab",
    label: "Compensation",
    permissions: [
      { backendProp: "allowDateHired", displayLabel: "Enable Date Hired", targetField: "dateHired", isDisabledField: true },
      { backendProp: "allowPayType", displayLabel: "Enable Pay Type", targetField: "payTypeId" },
      { backendProp: "allowContractPeriod", displayLabel: "Enable Contract Period", targetField: ["contractFrom", "contractTo"] },
      { backendProp: "allowOvertime", displayLabel: "Enable Entitled to Overtime", targetField: "entitledToOvertime" },
      { backendProp: "allowSalaryType", displayLabel: "Enable Salary Type", targetField: "salaryType" },
      { 
        // depending on one of th evalue SalaryType = MaintenaceSalaryCombination
        backendProp: "allowMaintenanceSalaryCombinationV2Id", 
        displayLabel: "Enable Salary Rate Category(Dynamic Salary)", 
        targetField: "maintenanceSalaryCombinationV2Id", 
        prerequisite: ["allowSalaryType", "allowSalaryRate", "allowEffectiveFrom"], 
        prerequisiteFromFilter: FEATURES.MAINTENANCE_SALARY_FILTERS,
      }, 
      { backendProp: "allowSalaryRate", displayLabel: "Enable Salary Rate/Amount", targetField: "rateAmount" },
    ]
  },
  "schedule": {
    tabLabel: "Schedule Tab",
    label: "Schedule",
    permissions: [
      { backendProp: "allowShiftSchedule", displayLabel: "Enable Shift Schedule", targetField: "shiftScheduleId" },
      { backendProp: "allowRestDay", displayLabel: "Enable Rest Day", targetField: "restDay" },
    ]
  },
  "other-access": {
    tabLabel: "Other Access",
    label: "Others",
    permissions: [
      { backendProp: "requiredSailingButtons", displayLabel: "Required Sailing Buttons?", targetField: [] },
    ]
  }
};